import { render } from "./ModalCreateUser.vue?vue&type=template&id=6b38cca6&scoped=true&ts=true"
import script from "./ModalCreateUser.vue?vue&type=script&lang=ts"
export * from "./ModalCreateUser.vue?vue&type=script&lang=ts"

import "./ModalCreateUser.vue?vue&type=style&index=0&id=6b38cca6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b38cca6"]])

export default __exports__